module.exports = __webpack_public_path__ + "img/info.36b528b8.svg";